import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import * as Objects from '@core/objects';
import { AddVersion } from '@core/models/add-version';
import { UrlService } from '@core/services/url/url.service'; 
import { CoreResponseUtilsService } from '@core/services/utils/response-utils.service'; // For testing

@Injectable({
    providedIn: 'root'
})
export class AddVersionRequests {
    private readonly versionsPrefix = '/versions'; 
    private readonly projectPrefix = '/requests';

    constructor(
        private http: HttpClient,
        private url: UrlService,
        private responseUtilsSrv: CoreResponseUtilsService
    ) {}

    submitAddVersion$(projectId: number, data: AddVersion): Observable<Objects.Version> {
        const postData = {
            files: data.files,
            labels: data.labels,
            version: data.version,
            subversion: data.subversion,
            status: data.status
        };

        return this.http.post<Objects.Version>(this.url.build(`${this.projectPrefix}/${projectId}${this.versionsPrefix}`), postData);
    }
}